import { Component, OnDestroy, OnInit } from '@angular/core';
import { debounceTime, distinctUntilChanged, Subject, takeUntil } from 'rxjs';
import { DELETE_QRIS, QRISLY_LIST } from 'src/app/constants/endpoint.const';
import { BaseService } from 'src/app/services/base.service';
import { PaginationResponse, QrisListResponseItem } from 'src/app/types/response/qrisly.response.type';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  standalone: false,
  selector: 'app-qris-list-table',
  templateUrl: './qris-list-table.component.html',
  styleUrl: './qris-list-table.component.scss'
})
export class QrisListTableComponent implements OnInit, OnDestroy {
  data: QrisListResponseItem[] = [];
  pagination: PaginationResponse = {
    current_page: 1,
    total_count: 0,
    total_pages: 0,
  }

  totalList: number = 0;
  isDisNext: boolean = false;
  isDisPrev: boolean = false;
  showDeleteModal: boolean = false;
  selectedQrisId: number = 0;

  filterList = {
    limit: 20,
    offset: 0,
    search: ''
  };

  private searchSubject = new Subject<string>();
  private destroy$ = new Subject<void>();

  constructor(
    private baseService: BaseService,
    private message: NzMessageService,
  ) {}

  ngOnInit(): void {
    this.getList();

    this.searchSubject.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      takeUntil(this.destroy$)
    ).subscribe(value => {
      this.filterList.search = value;
      this.getList();
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onPageChange(pageIndex: number) {
    this.filterList.offset = (pageIndex - 1) * this.filterList.limit;
    this.getList();
  }

  onPerPageChange(perPage: number) {
    this.filterList.limit = perPage;
    this.filterList.offset = 0;
    this.getList();
  }

  onChangeSearch(value: string) {
    if (value.length >= 3) {
      this.filterList.offset = 0;
      this.searchSubject.next(value);
    } else if (value.length === 0) {
      this.filterList.search = '';
      this.getList();
    }
  }

  getListPage(event: Event) {
    const target = event.target as HTMLInputElement;
    const perPage = Number(target.value);
    this.filterList.limit = perPage;
    this.filterList.offset = 0;
    this.getList();
  }

  getList() {
    this.baseService.getDataWithToken(QRISLY_LIST, this.filterList).subscribe({
      next: (res: { data: { list: QrisListResponseItem[]; pagination: PaginationResponse } }) => {
        this.data = res.data.list;
        this.pagination = res.data.pagination
      },
      error: (err) => {
        this.data = [];
        this.pagination.current_page = 1;
        this.pagination.total_count = 0;
        this.pagination.total_pages = 0;
        this.message.create('error', err.error.meta.message);
      }
    })
  }

  onDeleteQris(id: number) {
    this.showDeleteModal = true;
    this.selectedQrisId = id;
  }

  onDelete() {
    this.baseService.deleteDataWithToken(DELETE_QRIS + '/' + this.selectedQrisId, {}).subscribe({
      next: () => {
        this.message.create('success', 'QRIS deleted successfully');
        this.showDeleteModal = false;
        this.getList();
      },
      error: (err) => {
        this.message.create('error', err.error.meta.message);
      }
    })
  }
}
